import { Link } from 'react-router-dom';
import { getUpcomingActivities } from '@/mocks/activities';

export default function ActivitiesSection() {
  const upcomingActivities = getUpcomingActivities(6);

  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 gap-4">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2">
              即将开始的活动
            </h2>
            <p className="text-sm text-foreground-500">
              加入你感兴趣的活动，和志同道合的伙伴一起行动
            </p>
          </div>
          <Link
            to="/category/outdoor"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="text-sm text-primary-500 hover:text-primary-600 font-label whitespace-nowrap flex items-center gap-1 cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {upcomingActivities.map((activity) => (
            <div
              key={activity.id}
              className="bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-colors duration-300 group cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={activity.image}
                  alt={activity.title}
                  title={activity.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="bg-accent-500 text-background-50 text-xs px-2.5 py-1 rounded-full font-label whitespace-nowrap">
                    {activity.category}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-label font-medium text-foreground-900 mb-2 line-clamp-2 leading-snug">
                  {activity.title}
                </h3>
                <div className="flex flex-wrap items-center gap-3 text-xs text-foreground-500 mb-3">
                  <span className="flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-calendar-line"></i> {activity.date}
                  </span>
                  <span className="flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-map-pin-line"></i> {activity.location}
                  </span>
                </div>
                <div className="flex items-center justify-between pt-3 border-t border-background-200/70">
                  <div className="flex items-center gap-2">
                    <img
                      src={activity.hostAvatar}
                      alt={activity.host}
                      className="w-6 h-6 rounded-full object-cover"
                    />
                    <span className="text-xs text-foreground-600">{activity.host}</span>
                  </div>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">
                    {activity.participants}/{activity.maxParticipants}人
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}